module.exports = __webpack_public_path__ + "r-v3/img/ico_option_radio_not_checked.21e13a92.svg";